
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { IncidentEventTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-incidenteventtype-container',
  templateUrl: './incidenteventtype-container.component.html',
  styleUrls: ['./incidenteventtype-container.component.scss']
})
export class IncidenteventtypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentEventTypes$: Observable<IncidentEventTypeDto[]>;
  loading: boolean;
  isLoadingIncidentEventType$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingIncidentEventType$ = this.gatwayFacade.isLoadingGateway("IncidentEventType");
    this.incidentEventTypes$ = this.gatwayFacade.loadGateway("IncidentEventType");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIncidentEventType(deletedValue: any) {
    this.gatwayFacade.remove("IncidentEventType", deletedValue);
  }


// this method control both the create and update

  onSubmitIncidentEventType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentEventTypes;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllIncidentEventType = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIncidentEventType.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllIncidentEventType.length > 0) {
    this.gatwayFacade.add('IncidentEventType', addAllIncidentEventType);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('IncidentEventType', allUpdates, ['id']);
  }


}
}



  
   




